module.exports = __webpack_public_path__ + "static/media/instrucciones.567af259.png";